import { isReactClass } from './isReactClass';

/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isReactComponent(obj) {
  return obj && (isReactClass(obj) || typeof obj === 'function');
}